import React, { useRef } from "react";
import DashboardHeader from "../../../../components/dashboardHeader";
import CustomContainer from "../../../../components/container/CustomContainer";
import { appIcons } from "../../../../assets";
import { Grid, Typography } from "@mui/material";
import DashboardCard from "../../../../components/cards/DashboardCard";
import { useNavigate } from "react-router-dom";
import StudentCardDialog from "./StudentCardDialog";
import PaymentMethodDialog from "../../../../components/payMethodDialog.js";
import StudentIdCardDialog from "./StudentIdCardDialog.js";

const cardData = [
  {
    title: "Fee Structure",
    icon: appIcons.purpleFeesIcon,
    path: "fee-structure",
  },
  {
    title: "Report Card",
    icon: appIcons.purpleReportCardIcon,
    path: "report",
  },
  {
    title: "ID Card",
    icon: appIcons.purpleDeliveredIcon,
    path: "ID_card",
  },
  {
    title: "Time Table",
    icon: appIcons.purpleTimeTableIcon,
    path: "time-table",
  },
  {
    title: "Chat With Us",
    icon: appIcons.purpleChatIcon,
    path: "chat",
  },
];

const UserEducationDashboardPage = () => {
  const openCardDialog = useRef(null);
  const payMethodDialog = useRef(null);
  const openIdCardDialog = useRef(null);
  const navigate = useNavigate();

  const handleClickOnCard = (row, index) => {
    if (row?.path !== "ID_card") {
      navigate(`/dashboard/education/${row.path}`);
    }

    if (row?.path === "ID_card") {
      openCardDialog.current.openDialog();
    }
  };

  const handleRequestNewCard = () => {
    payMethodDialog.current.openDialog();
    openCardDialog.current.closeDialog();
  };

  const handleViewIDCard = () => {
    openCardDialog.current.closeDialog();
    openIdCardDialog.current.openDialog();
  };

  const handlePay = () => {
    openCardDialog.current.closeDialog();
    payMethodDialog.current.closeDialog();
  };

  return (
    <DashboardHeader>
      <CustomContainer
        primaryHeading={"Track Your Children"}
        secondaryHeading={"You have a Access"}
        showBackButton={true}
        handleBack={() => navigate("/dashboard")}
      >
        <Typography variant="h6" mb={3}>
          All Access Points{" "}
        </Typography>
        <Grid container rowSpacing={2} columnSpacing={2}>
          {cardData?.map((val, index) => {
            return (
              <Grid key={index} item xs={12} sm={4} md={3}>
                <DashboardCard
                  data={val}
                  index={index}
                  handleClickOnCard={handleClickOnCard}
                />
              </Grid>
            );
          })}
        </Grid>
      </CustomContainer>
      <StudentCardDialog
        ref={openCardDialog}
        handleRequestNewCard={handleRequestNewCard}
        handleViewIDCard={handleViewIDCard}
      />
      <StudentIdCardDialog ref={openIdCardDialog} />
      <PaymentMethodDialog ref={payMethodDialog} handleConfirm={handlePay} />
    </DashboardHeader>
  );
};

export default UserEducationDashboardPage;
